/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AllocatedPremiumScheduleResponseDto
 */
export interface AllocatedPremiumScheduleResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AllocatedPremiumScheduleResponseDto
     */
    premiumScheduleId: string;
    /**
     * 
     * @type {string}
     * @memberof AllocatedPremiumScheduleResponseDto
     */
    settlementExchangeRate?: string;
    /**
     * 
     * @type {string}
     * @memberof AllocatedPremiumScheduleResponseDto
     */
    contractPinnacleReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AllocatedPremiumScheduleResponseDto
     */
    submissionOriginalCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof AllocatedPremiumScheduleResponseDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof AllocatedPremiumScheduleResponseDto
     */
    reinsuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof AllocatedPremiumScheduleResponseDto
     */
    binderName?: string;
    /**
     * 
     * @type {string}
     * @memberof AllocatedPremiumScheduleResponseDto
     */
    bookedExchangeRate?: string;
    /**
     * 
     * @type {object}
     * @memberof AllocatedPremiumScheduleResponseDto
     */
    originalNetAmountDueBroker?: object;
    /**
     * 
     * @type {object}
     * @memberof AllocatedPremiumScheduleResponseDto
     */
    shareOfPremiumSigned?: object;
    /**
     * 
     * @type {object}
     * @memberof AllocatedPremiumScheduleResponseDto
     */
    paidAmount?: object;
    /**
     * 
     * @type {Date}
     * @memberof AllocatedPremiumScheduleResponseDto
     */
    ppwDueDate: Date;
    /**
     * 
     * @type {boolean}
     * @memberof AllocatedPremiumScheduleResponseDto
     */
    closing: boolean;
    /**
     * 
     * @type {string}
     * @memberof AllocatedPremiumScheduleResponseDto
     */
    closingReference?: string;
}

/**
 * Check if a given object implements the AllocatedPremiumScheduleResponseDto interface.
 */
export function instanceOfAllocatedPremiumScheduleResponseDto(value: object): value is AllocatedPremiumScheduleResponseDto {
    if (!('premiumScheduleId' in value) || value['premiumScheduleId'] === undefined) return false;
    if (!('ppwDueDate' in value) || value['ppwDueDate'] === undefined) return false;
    if (!('closing' in value) || value['closing'] === undefined) return false;
    return true;
}

export function AllocatedPremiumScheduleResponseDtoFromJSON(json: any): AllocatedPremiumScheduleResponseDto {
    return AllocatedPremiumScheduleResponseDtoFromJSONTyped(json, false);
}

export function AllocatedPremiumScheduleResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllocatedPremiumScheduleResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'premiumScheduleId': json['premiumScheduleId'],
        'settlementExchangeRate': json['settlementExchangeRate'] == null ? undefined : json['settlementExchangeRate'],
        'contractPinnacleReferenceNumber': json['contractPinnacleReferenceNumber'] == null ? undefined : json['contractPinnacleReferenceNumber'],
        'submissionOriginalCurrency': json['submissionOriginalCurrency'] == null ? undefined : json['submissionOriginalCurrency'],
        'insuredName': json['insuredName'] == null ? undefined : json['insuredName'],
        'reinsuredName': json['reinsuredName'] == null ? undefined : json['reinsuredName'],
        'binderName': json['binderName'] == null ? undefined : json['binderName'],
        'bookedExchangeRate': json['bookedExchangeRate'] == null ? undefined : json['bookedExchangeRate'],
        'originalNetAmountDueBroker': json['originalNetAmountDueBroker'] == null ? undefined : json['originalNetAmountDueBroker'],
        'shareOfPremiumSigned': json['shareOfPremiumSigned'] == null ? undefined : json['shareOfPremiumSigned'],
        'paidAmount': json['paidAmount'] == null ? undefined : json['paidAmount'],
        'ppwDueDate': (new Date(json['ppwDueDate'])),
        'closing': json['closing'],
        'closingReference': json['closingReference'] == null ? undefined : json['closingReference'],
    };
}

export function AllocatedPremiumScheduleResponseDtoToJSON(json: any): AllocatedPremiumScheduleResponseDto {
    return AllocatedPremiumScheduleResponseDtoToJSONTyped(json, false);
}

export function AllocatedPremiumScheduleResponseDtoToJSONTyped(value?: AllocatedPremiumScheduleResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'premiumScheduleId': value['premiumScheduleId'],
        'settlementExchangeRate': value['settlementExchangeRate'],
        'contractPinnacleReferenceNumber': value['contractPinnacleReferenceNumber'],
        'submissionOriginalCurrency': value['submissionOriginalCurrency'],
        'insuredName': value['insuredName'],
        'reinsuredName': value['reinsuredName'],
        'binderName': value['binderName'],
        'bookedExchangeRate': value['bookedExchangeRate'],
        'originalNetAmountDueBroker': value['originalNetAmountDueBroker'],
        'shareOfPremiumSigned': value['shareOfPremiumSigned'],
        'paidAmount': value['paidAmount'],
        'ppwDueDate': ((value['ppwDueDate']).toISOString()),
        'closing': value['closing'],
        'closingReference': value['closingReference'],
    };
}

